import { ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useAccountStore } from '@/stores/account'

export type ContactMethod = 'phone' | 'email'

function resolveDefaultContactMethod(phone: boolean, email: boolean): ContactMethod {
  if (phone && !email) return 'phone'
  if (email && !phone) return 'email'
  return phone ? 'phone' : 'email'
}

export function useContactFormChooser() {
  const { t } = useI18n()
  const { account } = storeToRefs(useAccountStore())

  const config = computed(() => account.value?.account_config_landing)
  const formPhoneEnabled = computed(() => config.value?.form_contact_phone_enabled ?? true)
  const formEmailEnabled = computed(() => config.value?.form_contact_email_enabled ?? false)
  const showContactMethodSegment = computed(() => formPhoneEnabled.value && formEmailEnabled.value)

  const contactMethod = ref<ContactMethod>('phone')

  const contactMethodOptions = computed(() => {
    const options: Array<{ value: ContactMethod; label: string }> = []
    if (formPhoneEnabled.value) options.push({ value: 'phone', label: t('index.contactForm.contactMethodPhone') })
    if (formEmailEnabled.value) options.push({ value: 'email', label: t('index.contactForm.contactMethodEmail') })
    return options
  })

  watch(
    [formPhoneEnabled, formEmailEnabled],
    ([phone, email]) => {
      contactMethod.value = resolveDefaultContactMethod(!!phone, !!email)
    },
    { immediate: true }
  )

  return {
    contactMethod,
    contactMethodOptions,
    showContactMethodSegment,
    formPhoneEnabled,
    formEmailEnabled,
  }
}
